export default "__VITE_ASSET__e7fd8699__"